import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const amendmentDetailsValidationSchema = (
  amendmentType: string,
  isGroupPolicy = false
) =>
  Yup.object({
    amendmentDetails: Yup.object({
      amendmentType: requiredText(),
      amendmentSubType:
        amendmentType === 'PolicyCancellation' || isGroupPolicy
          ? Yup.string().notRequired()
          : requiredText(),
      amendmentIssueDate: requiredText(),
      amendmentEffectiveDate: requiredText()
    })
  });
